import { nullishToOptional } from "../../../helpers/nullish-to-optional";
import { z } from "zod";
//
// Enums
//
export const FigmaNodeRenderState = z.enum(["InProgress", "Success", "Failed"]);
export const FigmaNodeRenderFormat = z.enum(["Png", "Svg"]);
export const FigmaNodeRenderErrorType = z.enum([
    "MissingIntegration",
    "NodeNotFound",
    "RenderError",
]);
//
// Definition
//
export const FigmaNodeRelinkData = z.object({
    fileId: z.string(),
});
export const FigmaNodeRenderedImage = z.object({
    resourceId: z.string(),
    format: FigmaNodeRenderFormat,
    scale: nullishToOptional(z.number()),
    width: nullishToOptional(z.number()),
    height: nullishToOptional(z.number()),
    url: nullishToOptional(z.string()),
    originKey: nullishToOptional(z.string()),
});
export const FigmaNodeRenderError = z.object({
    type: FigmaNodeRenderErrorType,
});
export const FigmaNodeReferenceData = z.object({
    sceneNodeId: z.string(),
    format: FigmaNodeRenderFormat,
    scale: nullishToOptional(z.number()),
    useAbsoluteBounds: nullishToOptional(z.boolean()),
    renderState: FigmaNodeRenderState,
    renderedImage: FigmaNodeRenderedImage.optional(),
    renderError: FigmaNodeRenderError.optional(),
    hasSource: z.boolean(),
    relinkData: FigmaNodeRelinkData.optional(),
});
